import React from 'react'
import { FullBlockLoader, CircleLoader } from '@deal/components'
import LineItem from './components/LineItem'
import Footer from './components/Footer'
import ChatWithExpert from './components/ChatWithExpert'
import EmptyCart from '../components/EmptyCart'
import { GuestCartConsumer } from '#src/containers/Cart'
import { GuestSellablesComponent } from '#src/generated/graphql'
// @ts-ignore TODO: Write typings for react-scrolllock
import { TouchScrollable } from 'react-scrolllock'
import styles from './styles.css'

const GuestCartContainer: React.SFC = () => {
  return (
    <GuestCartConsumer>
      {({ data: guestCartData }) => (
        <div className={styles.content}>
          <TouchScrollable>
            <div className={styles.cartContents} data-testid="guest-cart-contents">
              {guestCartData && guestCartData.order.length > 0 ? (
                <GuestSellablesComponent
                  variables={{
                    ids: guestCartData.order.map(guestSellable => guestSellable.id)
                  }}
                >
                  {({ data: sellableData, loading }) => {
                    if (loading) {
                      return <FullBlockLoader loader={CircleLoader} />
                    } else if (sellableData && sellableData.sellables) {
                      return (
                        <>
                          <ChatWithExpert />
                          <div className={styles.lineItems}>
                            {sellableData.sellables.map(sellable => (
                              <LineItem
                                key={sellable.id}
                                sellable={sellable}
                                sellableInStorage={guestCartData.order.find(
                                  guestSellable => guestSellable.id === sellable.id
                                )}
                                onRemoveSellable={sellableId =>
                                  guestCartData.removeGuestCartItem(sellableId)
                                }
                                onUpdateQuantity={(sellableId, quantity) =>
                                  guestCartData.updateGuestCartItemQuantity(sellableId, quantity)
                                }
                              />
                            ))}
                          </div>
                        </>
                      )
                    }

                    return <EmptyCart />
                  }}
                </GuestSellablesComponent>
              ) : (
                <EmptyCart />
              )}
            </div>
          </TouchScrollable>
          <div className={styles.footer}>
            <Footer />
          </div>
        </div>
      )}
    </GuestCartConsumer>
  )
}

export default GuestCartContainer
